const HomePageTitle = (props) => {
  let classes = "page-title site-text-blue";
  return <h1 className={classes}>{props.title}</h1>;
};
export default HomePageTitle;
